import Injectable from '@/modules/shared/domain/dependency_injection/injectable';
import Inject from '@/modules/shared/domain/dependency_injection/inject';
import Query from '@/modules/shared/domain/services/query';
import TYPES from '../../types';
import { StateManager } from '../../domain/state/state-manager';
import { FinancialInstitutionRepository } from '../../domain/repository/financial-institution-repository';
import { FinancialInstitutionEntity } from '../../domain/entities/financial-institution-entity';

@Injectable()
class GetFinancialInstitutionsQueryService extends Query<Array<FinancialInstitutionEntity>> {
  @Inject(TYPES.ONBOARDING_FINANCIAL_INSTITUTION_STATE_MANAGER)
  private readonly state_manager!: StateManager;

  @Inject(TYPES.FINANCIAL_INSTITUTION_REPOSITORY)
  private readonly repository!: FinancialInstitutionRepository;

  internalExecute() {
    if (this.state_manager.state.items.length < 1) {
      this.repository.findAll()
        .then((items) => {
          this.state_manager.patch({ items });
        });
    }

    return this.state_manager.state.items;
  }
}

export default GetFinancialInstitutionsQueryService;
